const mainObj = {
    isShow: "0",
    title: "Maintenance and upgrade notice",
    content_en: "Dear user, in order to bring you a better experience, this site will carry out system maintenance and upgrade immediately, APP-related services will be suspended during the maintenance period, sorry for the inconvenience caused to you! Maintenance time: 2022-12-30 00:30-01:00 If you have any questions, please contact customer service",
    service_link_vn: "https://vue.livehelp100service.com/chatwindow.aspx?siteId=60003972&&Chatgroup=2&planId=f7f6317b-12ab-487e-96bc-72af5ff3b009"
}

export default {
    mainObj
};